<template>
  <div class="app-container" style="position: relative;width: 100%;">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <!--导航栏-->
      <van-nav-bar :title="$route.meta.title" left-arrow>
        <!--返回-->
        <van-icon slot="left" name="left" class-prefix="iconfont" @click="handleBack" />
        <!--刷新-->
        <van-icon slot="right" name="refresh" class-prefix="iconfont" @click="handleRefresh" />
      </van-nav-bar>
      <!--提示-->
      <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o" class="notice-bar">
        <span>1、本查询信息范围仅限于{{ qxmc }}。</span>
        <span>2、如信息有误请与我中心联系，联系电话：{{ lxdh }}。</span>
        <span>3、本查询信息为系统自动显示，仅供参考使用，不作为判断依据。(2016年1月1日前房产信息最终解释权归原登记机关)</span>
      </van-notice-bar>
      <!--头部-->
      <div class="header">
        <div :class="['circle',activeStatus.toLowerCase()]">
          <div class="info">
            <div>我的房卡</div>
            <div class="count">
              {{ getHouseCount() }}
            </div>
            <div>认证姓名：{{ webUserInfo.realName }}</div>
          </div>
        </div>
      </div>
      <!--标签栏-->
      <van-tabbar
        v-model="activeStatus"
        :fixed="false"
        :border="false"
        :active-color="activeColor"
      >
        <van-tabbar-item
          v-for="houseStatus in houseStatuses"
          :key="houseStatus.key"
          :name="houseStatus.key"
          :info="getHouseCount(houseStatus.key)"
          class="tabbar-item"
        >
          <van-icon
            slot="icon"
            slot-scope="props"
            class="tabbar-item__icon"
            :name="props.active|tabbarIconName"
            class-prefix="iconfont"
          />
          <div class="tabbar-item__text">
            {{ houseStatus.text }}
          </div>
        </van-tabbar-item>''
      </van-tabbar>
      <div
        v-if="activeHouses.length>0"
        class="house-list"
      >
        <div
          v-for="house in activeHouses"
          :key="house.landAndHouseProperty.bSM"
          class="house-list-item"
        >
          <router-link to="/houses/certificate">
            <div class="location">
              <van-icon class-prefix="iconfont" name="map-fill" size="20px" />
              {{ house.landAndHouseProperty.fDZL }}
            </div>
            <div class="householder">
              <van-icon class-prefix="iconfont" name="people-fill" size="20px" />
              {{ house.landAndHouseProperty.qLRMC }}
            </div>
            <div class="status">
              <van-icon class-prefix="iconfont" name="prompt-fill" size="20px" />
              {{ getHouseStatus(house).text }}
            </div>
          </router-link>
        </div>
      </div>
      <div v-else>
        <p style="text-align:center">
          暂无相关数据
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { HouseStatus } from '@/utils/enums'
import { mapGetters } from 'vuex'
import to from 'await-to-js'
import { Toast } from 'vant'
import { getSystemConfig } from '@/api/systemConfig.js'
export default {
  filters: {
    tabbarIconName: function(active) {
      return active ? 'building-fill' : 'building'
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      activeStatus: 'Normal',
      houses: [],
      qxmc: 'xxx', // 区县名称
      lxdh: 'xxxx-xxxxxxxx' // 联系电话
    }
  },
  computed: {
    ...mapGetters(['webUserInfo']),
    // 房屋状态
    houseStatuses() {
      return HouseStatus.getItems()
    },
    // 激活的颜色
    activeColor() {
      switch (this.activeStatus) {
        case 'Normal':
          return '#07c160'
        case 'Mortgaged':
          return '#ff976a'
        case 'Sequestrated':
          return '#ee0a24'
        default:
          return '#1989fa'
      }
    },
    // 正常状态房屋
    normalHouses() {
      return this.houses.filter(b => b.mortgages.length === 0 && b.sequestrations.length === 0)
    },
    // 抵押状态房屋
    mortgagedHouses() {
      return this.houses.filter(b => b.mortgages.length > 0)
    },
    // 查封状态房屋
    sequestratedHouses() {
      return this.houses.filter(b => b.sequestrations.length > 0)
    },
    // 激活状态房屋
    activeHouses() {
      return this[this.activeStatus.toLowerCase() + 'Houses']
    }
  },
  created() {
    // 加载数据
    this.loadData()
    // 加载系统配置
    this.loadSystemConfig()
  },
  mounted() {
  },
  methods: {
    // 加载数据
    async loadData() {
      const [error, houses] = await to(
        this.$store.dispatch('application/getHouseBusinesses')
      )
      if (error) {
        // 设置错误信息
        this.errorMessage = error.message
      }
      // 设置个人房产
      this.houses = houses
      // 设置加载状态为已加载
      this.isLoaded = true
    },
    // 处理刷新事件
    async handleRefresh() {
      // 显示加载进度
      Toast.loading({ message: '刷新中...', duration: 0 })
      const [error, houses] = await to(
        this.$store.dispatch('application/getHouseBusinesses', true)
      )
      if (error) {
        // 加载失败，显示错误信息
        Toast.fail(error.message)
      } else {
        // 加载成功
        Toast.success('刷新成功')
        // 设置个人房产
        this.houses = houses
      }
    },
    // 处理返回事件
    handleBack() {
      this.$router.go(-1)
    },
    // 获取房屋数量
    getHouseCount: function(status) {
      if (status) {
        return this[status.toLowerCase() + 'Houses'].length
      } else {
        return this.houses.length
      }
    },
    // 获取房屋状态
    getHouseStatus: function(house) {
      if (house.sequestration) {
        return HouseStatus.Sequestrated
      } else if (house.mortgages.length > 0) {
        return HouseStatus.Mortgaged
      } else {
        return HouseStatus.Normal
      }
    },
    // 获取系统配置（区县名称、联系电话）
    loadSystemConfig() {
      getSystemConfig({
        'key': 'DJXT_QXMC'
      }).then(response => {
        this.qxmc = response.data.value
      })
      getSystemConfig({
        'key': 'DJXT_LXDH'
      }).then(response => {
        this.lxdh = response.data.value
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
  .loading {
    padding-top: 15px;
    text-align: center;
  }
  .error-message {
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .van-nav-bar {
    .van-nav-bar__left {
      .iconfont {
        color: #969799;
        font-size: 24px;
        vertical-align: middle;
      }
    }
    .van-nav-bar__right {
      .iconfont {
        color: #969799;
        font-size: 24px;
        vertical-align: middle;
      }
    }
  }
  .notice-bar span{
    margin-right:10px;
  }
  .header {
    width: 100%;
    padding: 30px 0px 102px 0px;
    color: #fff;
    background: #303a5b url(../../assets/images/buildings.png) no-repeat bottom;
    background-size: 100% auto;
    filter: alpha(opacity=50);
    .circle {
      width: 200px;
      height: 200px;
      border-radius: 50%;
      border-style: solid;
      border-width: 4px;
      margin: 0px auto;
      text-align: center;
      .info {
        padding-top: 40px;
        .count {
          font-size: 60px;
          font-weight: bold;
        }
      }
    }
    .circle.normal {
      border-color: rgba(7, 193, 96, 0.75);
      box-shadow: 0 0 30px rgb(7, 193, 96, 0.75);
    }
    .circle.mortgaged {
      border-color: rgba(255, 151, 106, 0.75);
      box-shadow: 0 0 30px rgb(255, 151, 106, 0.75);
    }
    .circle.sequestrated {
      border-color: rgba(238, 10, 36, 0.75);
      box-shadow: 0 0 30px rgb(238, 10, 36, 0.75);
    }
  }
  .van-tabbar {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    width: calc(100% - 20px);
    margin: -72px auto 0px;
    height: 72px;
    .tabbar-item {
      .tabbar-item__icon {
        font-size: 30px;
      }
      .tabbar-item__text {
        font-size: 14px;
      }
    }
  }
  .house-list{
    .house-list-item{
      height: 100px;
      margin: 10px 10px 0px 10px;
      padding: 10px;
      font-size: 14px;
      background: #fff url(../../assets/images/houses.png) no-repeat bottom -2px right -140px;
      background-size: auto 100%;
      border-radius: 4px;
      box-shadow: 0px 2px 3px #bcbcbc;
      color: #333;
      .location{
        font-size: 16px;
        .iconfont {
          vertical-align: -2px;
        }
      }
      .householder{
        margin-top: 5px;
        font-size: 20px;
        // font-weight: bold;
        .iconfont {
          vertical-align: -1px;
        }
      }
      .status{
        margin-top: 5px;
        .iconfont {
          vertical-align: -1px;
        }
      }
    }
  }

}
</style>
